/**
 * Engine API
 * Civilization Engine API
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Action
 */
export interface BattleExistedFrontAction { 
    /**
     * Civilization name
     */
    civilizationName: string;
    /**
     * Unit uuid
     */
    unitUuid: string;
    /**
     * Unit health
     */
    unitHealth: number;
    /**
     * Unit strength
     */
    unitStrength: number;
    /**
     * Front number, started with 1
     */
    frontNumber: number;
}